var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.818,
    height: 20,
    viewBox: "0 0 15.818 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(-1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M11.659,1.25c1.747,0,3.164,1.119,3.164,2.5v5H8.5v-5C8.5,2.369,9.912,1.25,11.659,1.25ZM16.4,8.75v-5C16.4,1.679,14.28,0,11.659,0S6.914,1.679,6.914,3.75v5c-1.747,0-3.164,1.119-3.164,2.5V17.5c0,1.381,1.416,2.5,3.164,2.5H16.4c1.747,0,3.164-1.119,3.164-2.5V11.25C19.568,9.869,18.152,8.75,16.4,8.75ZM6.914,10H16.4a1.446,1.446,0,0,1,1.582,1.25V17.5A1.446,1.446,0,0,1,16.4,18.75H6.914A1.446,1.446,0,0,1,5.332,17.5V11.25A1.446,1.446,0,0,1,6.914,10Z",
    transform: "translate(0)",
    fill: "#6b7280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.d3834b881791105f4a838424a38ac72a.svg";
export { ForwardRef as ReactComponent };